import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-reach-alert-popup',
  standalone: true,
  imports: [],
  templateUrl: './reach-alert-popup.component.html',
  styleUrl: './reach-alert-popup.component.scss'
})
export class ReachAlertPopupComponent {

  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { message: string },
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ReachAlertPopupComponent>,
    private toaster: ToastrService,
   
  ) {}

  closeReachLocatonDialog(): void{
    this.dialogRef.close();
  }

}
